import styled, { css } from 'styled-components';
import Button from '../Button/Button.js';

const ButtonWrapper = styled(Button) `
  align-items: 'center',
  justify-content: 'center',
  border-radius: ${({ theme }) => theme.olist.borderRadius.circle};
  display: inline-flex;
  border: none;
  padding: ${({ theme }) => theme.olist.spacing.inline['2xsmall']};

  :hover {
    background-color: ${({ theme }) => theme.olist.color.neutral.softer};

    svg path {
      fill: ${({ theme }) => theme.olist.color.primary.base};
    }
  }
  ${({ copied }) => copied &&
    css `
      svg path {
        fill: ${({ theme }) => theme.olist.color.success.base};
      }

      :hover {
        svg path {
          fill: ${({ theme }) => theme.olist.color.success.base};
        }
      }
    `};
`;

export { ButtonWrapper as default };
